import { Routes, Route } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// Layout components
import LayoutWrapper from "./components/LayoutWrapper";

// Page components
import Home from "./pages/Home";
import About from "./pages/About";
import Teaching from "./pages/Teaching";
import Publications from "./pages/Publications";
import PatentsAwards from "./pages/PatentsAwards";
import Projects from "./pages/Projects";
import ProjectDetail from "./pages/ProjectDetail";
import Blog from "./pages/Blog";
import BlogPost from "./pages/BlogPost";
import LectureStudioRedirect from "./pages/LectureStudioRedirect";
import NotFound from "./pages/NotFound";
import YZDunya from "./pages/YZDunya";

function App() {
  return (
    <LayoutWrapper>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/teaching" element={<Teaching />} />
        <Route path="/course/*" element={<LectureStudioRedirect />} />
        <Route path="/publications" element={<Publications />} />
        <Route path="/patents-awards" element={<PatentsAwards />} />
        <Route path="/projects" element={<Projects />} />
        <Route path="/projects/:slug" element={<ProjectDetail />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/blog/*" element={<BlogPost />} />
        <Route path="/yz-dunya" element={<YZDunya />} />
        <Route path="*" element={<NotFound />} />
      </Routes>

      <ToastContainer
        position="bottom-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={true}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
    </LayoutWrapper>
  );
}

export default App;
